/**
 * @file envRegistry.ts
 *
 * Runtime registry mapping organizationId or environment values to their 
 * corresponding env string. Populated at module-load time by plugin 
 * registrations so that no core module needs hardcoded knowledge of 
 * plugin-specific IDs.
 *
 * Example — in grabcadPlugin.ts:
 *   registerEnvironmentEnv('GrabCAD', 'grabcad');
 */

const _orgIdToEnv = new Map<number, string>();
const _environmentToEnv = new Map<string, string>();

/** Register an organizationId → env mapping. Called by plugin modules on load. */
export function registerOrgIdEnv(orgId: number, env: string): void {
  _orgIdToEnv.set(orgId, env);
}

/** Return the env string registered for the given organizationId, or undefined. */
export function getEnvForOrgId(orgId: number): string | undefined {
  return _orgIdToEnv.get(orgId);
}

/** Register an environment string → env mapping. Called by plugin modules on load. */
export function registerEnvironmentEnv(environment: string, env: string): void {
  _environmentToEnv.set(environment, env);
}

/** Return the env string registered for the given environment name, or undefined. */
export function getEnvForEnvironment(environment: string): string | undefined {
  return _environmentToEnv.get(environment);
}
